<template>
  <v-modal
    id="admin-user-agency-details-modal"
    size="lg"
    @closed="$emit('closed')"
  >
    <modal-header>
      <modal-title>
        {{ $t('admin.user.agency') }}
      </modal-title>
    </modal-header>

    <modal-body class="justify-content-between d-flex flex-column item-details">
      <the-admin-agency-details-basic-information
        :agency="agency"
        @reload-agency="$emit('reloadItem')"
      />
    </modal-body>
  </v-modal>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import VModal from '@/components/vendor/basic/modal/VModal.vue';
import ModalHeader from '@/components/vendor/basic/modal/ModalHeader.vue';
import ModalTitle from '@/components/vendor/basic/modal/ModalTitle.vue';
import ModalBody from '@/components/vendor/basic/modal/ModalBody.vue';
import Agency from '@/api/objects/Agency';
import TheAdminAgencyDetailsBasicInformation
  from '@/components/admin/agency/parts/TheAdminAgencyDetailsBasicInformation.vue';

export default defineComponent({
  name: 'TheAdminUserAgencyDetailsModal',
  components: {
    TheAdminAgencyDetailsBasicInformation,
    ModalBody,
    ModalTitle,
    ModalHeader,
    VModal,
  },
  emits: [
    'closed',
    'reloadItem',
  ],
  props: {
    agency: {
      type: Agency,
      required: true,
    },
  },
});
</script>
